import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ApprovalPendingMessage from './ApprovalPendingMessage';
import { auth } from '../config/firebase';

export default function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading state while auth is being determined
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Double check auth state with Firebase directly
  if (!currentUser && !auth.currentUser) {
    // Store the current URL before redirecting
    localStorage.setItem('auth_redirect', location.pathname + location.search);
    return <Navigate to="/login" />;
  }

  // If we have an auth.currentUser but no currentUser in context, wait for context to catch up
  if (!currentUser && auth.currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user is pending approval, has completed onboarding, and not accessing profile or company setup
  if (currentUser?.role === 'gerente' && 
      currentUser.approvalStatus === 'pending' &&
      currentUser.onboardingCompleted === true &&
      !['/profile', '/company-setup'].includes(location.pathname)) {
    return <ApprovalPendingMessage />;
  }
  
  // If user has not completed onboarding, redirect to onboarding
  if (currentUser?.role === 'gerente' && 
      currentUser.onboardingCompleted === false &&
      location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" />;
  }

  // Check if user is blocked
  if (currentUser?.approvalStatus === 'blocked') {
    return <ApprovalPendingMessage blocked />;
  }

  return <>{children}</>;
}